
import React, { useEffect, useState } from "react";

const LRTPage = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Dashboard LRT"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=149&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDk5ODc2NDc5LCJJZGVudGl0eSI6MTQ5LCJUb2tlblR5cGUiOjB9.sJKqCbYJ8-HRDbA7m0cSWRhVVyKS5u_AqYcr_XAgjnk&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};


export default LRTPage;
